import React from 'react'
import { IdentifierHeader, IdentifyWithPhoneForm } from '@/features/auth'
import { BaseView } from '@/components'

export const IdentifyWithPhoneScreen: React.FC = () => {
  return (
    <BaseView flex={1} gap={20} px={12}>
      <IdentifierHeader translationKey="form:labels.enterYourPhone" />
      <div className="h-full justify-between flex flex-col">
        <IdentifyWithPhoneForm />
      </div>
    </BaseView>
  )
}
